import { render, staticRenderFns } from "./AddAdministratorComponent.vue?vue&type=template&id=302b2bef&"
import script from "./AddAdministratorComponent.vue?vue&type=script&lang=js&"
export * from "./AddAdministratorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports